import {useQuery} from '@tanstack/react-query';
import {VerdocsEndpoint} from '@verdocs/js-sdk';
import {invalidateQuery} from './utils';

export type TMcpScope = 'read' | 'templates:write' | 'envelopes:write' | 'org:write' | 'debug' | 'destructive';

export interface IMcpToken {
  id: string;
  name: string;
  /** "vd_mcp_" plus the first 5 hex characters, for display. */
  token_prefix: string;
  scopes: TMcpScope[];
  global_admin: boolean;
  created_at: string;
  last_used_at: string | null;
  expires_at: string | null;
  /** Only present on the create and rotate responses. */
  token?: string;
}

export interface ICreateMcpTokenRequest {
  name: string;
  scopes: TMcpScope[];
  global_admin?: boolean;
  expires_in_days?: number | null;
}

// There are no js-sdk functions for these yet, so we call the endpoints directly
export const useMcpTokens = (profileId: string | undefined) =>
  useQuery({
    enabled: !!profileId,
    queryKey: ['mcp_tokens', profileId],
    queryFn: () =>
      VerdocsEndpoint.getDefault()
        .api.get<IMcpToken[]>('/v2/mcp-tokens')
        .then((r) => r.data),
  });

export const createMcpToken = (params: ICreateMcpTokenRequest) =>
  VerdocsEndpoint.getDefault()
    .api.post<IMcpToken>('/v2/mcp-tokens', params)
    .then((r) => {
      invalidateQuery(['mcp_tokens']);
      return r.data;
    });

export const rotateMcpToken = (id: string) =>
  VerdocsEndpoint.getDefault()
    .api.post<IMcpToken>(`/v2/mcp-tokens/${id}/rotate`)
    .then((r) => {
      invalidateQuery(['mcp_tokens']);
      return r.data;
    });

export const deleteMcpToken = (id: string) =>
  VerdocsEndpoint.getDefault()
    .api.delete(`/v2/mcp-tokens/${id}`)
    .then(() => invalidateQuery(['mcp_tokens']));
